module.exports = __webpack_public_path__ + "media/images/icons/icn_031-2b5d1a801e2b97019082a5f111aab167.svg";